import { ViewHeaderInterface } from './interfaces';

export const viewHeaderInitialState: ViewHeaderInterface = {
  isMobileOpen: false,
  isDesktopOpen: false,
};
